import { Injectable } from '@angular/core';
import {
  NAVIGATION_UTILISATEUR_RESPONSABLE,
  NAVIGATION_UTILISATEUR_RESPONSABLE_HIERARCHIE,
  NAVIGATION_UTILISATEUR_NON_RESPONSABLE,
  NAVIGATION_UTILISATEUR_NON_RESPONSABLE_SANS_N1,
  NAVIGATION_UTILISATEUR_NON_RESPONSABLE_SANS_N1_HIERARCHIE,
  NAVIGATION_UTILISATEUR_NON_RESPONSABLE_HIERARCHIE,
  NAVIGATION_UTILISATEUR_RESPONSABLE_SANS_N1,
  NAVIGATION_UTILISATEUR_RESPONSABLE_SANS_N1_HIERARCHIE
} from './navigation-data-utilisateur';
import { GlobalVariableService } from '../services/global-variable.service';
import { LocalStorageService } from 'ngx-webstorage';
import {
  NAVIGATION_ADMIN,
  NAVIGATION_DIRECTEUR,
  NAVIGATION_DIRECTEUR_HIERARCHIE,
  NAVIGATION_DRHA,
  NAVIGATION_CONSEIL,
  NAVIGATION_GRH,
  NAVIGATION_SUPER,
  NAVIGATION_RESPONSABLE_OFA,
  NAVIGATION_SUPER_ADMIN,
  NAVIGATION_SUPER_ADMIN_HIERARCHIE,
} from './navigation-data-admin';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  public menu: any = [];
  constructor(
    private variable: GlobalVariableService, 
    private storage: LocalStorageService
    ) { }

    
      private filterEIAItems(menu: any[]): any[] {
        return menu.filter(item => {
          if (item.heading && item.title === 'EIA') {
            return true;
          }
          if (item.title === 'Gestion des campagnes') {
            item.childrens = item.childrens.filter(child => child.service === 'eia' || child.service === '*');
            return true;
          }
          return false;
        });
      }
    
      private filterOFAItems(menu: any[]): any[] {
        return menu.filter(item => {
          if (item.heading && item.title === 'OFA') {
            return true;
          }
          if (item.title === 'Gestion OFA') {
            item.childrens = item.childrens.filter(child => child.service === 'ofa' || child.service === '*');
            return true;
          }
          return false;
        });
      }
    
      public filterMenuItems(menu: any[], userSlug: any, is_directeur_general?: boolean, is_hierarchie?: boolean) {
        return menu.filter(item => {
          if ((item.title === 'Consultations' && userSlug) || (item.title === 'MES OFA' && !userSlug)) {
            return false;
          }

          if ((item.title === 'MES EIA' && !is_hierarchie)) {
            return false;
          }
      
          // If the item has children, filter them as well
          if (item.childrens) {
            item.childrens = item.childrens.filter(child => {
              // Cache 'Moi' seulement si is_directeur_general existe
              if (child.title === 'Moi' && is_directeur_general) {
                return false;
              }
              if (child.title === 'Vue étendue' && !is_hierarchie) {
                return false;
              }
              return true;
            });
          }
          // Only include the item if it has children or if it doesn't need to have children
          return !item.childrens || item.childrens.length > 0;
        });
      }
    

  getNavigation() {
    let userSlug, withN1, isDg, canOfa, isHierarchie, abc;
    
    const user = JSON.parse(this.variable.getUser());
    userSlug = user?.profil?.slug;
    isHierarchie = user?.is_hierarchie;
    isDg = user?.is_directeur_general;
    canOfa = user?.ofa_is_active;
    withN1 = localStorage.getItem('n-1');

    if (userSlug === 'responsable-structure') {
      return this.filterMenuItems(NAVIGATION_UTILISATEUR_RESPONSABLE_HIERARCHIE, canOfa, abc, isHierarchie) || [];
    } 

     if (userSlug === 'agent' && withN1 === 'not-exist') {
      return this.filterMenuItems(NAVIGATION_UTILISATEUR_NON_RESPONSABLE_SANS_N1, canOfa, abc, isHierarchie) || [];
    } 

    else if (userSlug === 'agent' && withN1 === 'exist') {
      return this.filterMenuItems(NAVIGATION_UTILISATEUR_NON_RESPONSABLE, canOfa, abc, isHierarchie) || [];
    } 
    
    else if (userSlug === 'administrateur') {
      return NAVIGATION_ADMIN || [];
    }
    
    else if (userSlug === 'responsable-ofa') {
      return this.filterMenuItems(NAVIGATION_UTILISATEUR_RESPONSABLE, abc, abc, isHierarchie) || [];
    }

 else if (userSlug === 'directeur') {
    return this.filterMenuItems(NAVIGATION_DIRECTEUR_HIERARCHIE, canOfa, isDg, isHierarchie) || [];
  } 

    else if (userSlug === 'conseil-direction') {
      return this.filterMenuItems(NAVIGATION_CONSEIL, abc, abc, isHierarchie) || [];
    } 

    else if (userSlug === 'formations') {
      return this.filterMenuItems(NAVIGATION_SUPER, abc, abc, isHierarchie) || [];
    } 
  

    else if (userSlug === 'pvch-eia') {
      return this.filterEIAItems(NAVIGATION_GRH) || [];
    } 
    
    else if (userSlug === 'pvch-exceptionnel') {
      return NAVIGATION_GRH || [];
    }

    else if (userSlug === 'pvch-ofa') {
      return this.filterOFAItems(NAVIGATION_GRH) || [];
    }
   
    return this.filterMenuItems(NAVIGATION_SUPER_ADMIN, abc, abc, isHierarchie) || [];
  }
}
